$(document).ready(function () {
	var $showMore = $('.show-more');
	var $resourceFilter = $('#resource-filter');
	var $resources = $('.resource');
	var urlParam = location.search.split('type=')[1];

	$showMore.on('click', function() {
		$resources.removeClass('hide');
		$(this).hide();
	});

	$resourceFilter.on('change', function() {
		var option = $(this).val();
		$resources.each(function() {
			var type = $(this).data('type');
			$showMore.hide();

			if (option === 'all' || type === option) {
				$(this).removeClass('hide');
				return;
			}

			$(this).addClass('hide');
		});
	});

	// trigger change if url type is defined
	if (urlParam && urlParam !== 'all' && $resourceFilter.find('option[value="'+ urlParam +'"]').length) {
		$resourceFilter.val(urlParam).trigger('change');
	}
});